import React from "react";
import { Stack, Typography, Box, Divider } from "@mui/material";
import PeopleIcon from "@mui/icons-material/People";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import SchoolIcon from "@mui/icons-material/School";

const STYLES = {
  students: { icon: PeopleIcon,         bg: "#dbeafe", fg: "#2563eb" },
  parents:  { icon: FamilyRestroomIcon, bg: "#fce7f3", fg: "#db2777" },
  tutors:   { icon: SchoolIcon,         bg: "#dcfce7", fg: "#16a34a" },
};

const ROWS = [
  { key: "students", label: "Total Students" },
  { key: "parents",  label: "Total Parents" },
  { key: "tutors",   label: "Total Tutors" },
];

export default function PlatformSummary({ summary }) {
  const s = summary || { students: 0, parents: 0, tutors: 0 };
  return (
    <Box>
      <Typography variant="subtitle2" fontWeight={700} mb={1} sx={{ color: "#111827" }}>Platform Summary</Typography>
      <Stack divider={<Divider flexItem />} spacing={1}>
        {ROWS.map((r) => {
          const cfg = STYLES[r.key];
          const Icon = cfg.icon;
          const value = Number(s[r.key] || 0).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
          return (
            <Stack key={r.key} direction="row" alignItems="center" spacing={1}>
              <Box
                sx={{
                  width: 28, height: 28, borderRadius: 1,
                  bgcolor: cfg.bg, color: cfg.fg,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <Icon sx={{ fontSize: 16 }} />
              </Box>
              <Typography variant="caption" sx={{ flex: 1, color: "#374151", fontWeight: 700 }}>{r.label}</Typography>
              <Typography variant="body2" fontWeight={700} sx={{ color: "#111827" }}>{value}</Typography>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
}
